import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Sidebar.css";
import { FiLogOut } from 'react-icons/fi';
import { FaTachometerAlt, FaUser, FaStar } from "react-icons/fa";
import logo from "../images/Logo_Shubhjiwan.jpg"; 

const Sidebar = () => {
  const navigate = useNavigate();

  // Logout function
  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    navigate("/"); // Redirect to login page
  };

  return (
    <div className="sidebar">
      {/* Logo & Title */}
      <div className="sidebar-header">
        <img src={logo} alt="Logo" className="sidebar-logo" />
        <h2 className="sidebar-title"></h2>
      </div>

      {/* Navigation Links */}
    

<ul className="sidebar-menu">
  <li>
    <Link to="/admin/dashboard">
      <FaTachometerAlt style={{ marginRight: "8px" }} /> Dashboard
    </Link>
  </li>
  <li>
    <Link to="/admin/profile-management">
      <FaUser style={{ marginRight: "8px" }} /> Profile Management
    </Link>
  </li>
  <li>
    <Link to="/admin/success-stories">
      <FaStar style={{ marginRight: "8px" }} /> Success Stories
    </Link>
  </li>
  {/* <li>
    <Link to="/admin/pricing-plans">
      <FaDollarSign style={{ marginRight: "8px" }} /> Pricing Plans
    </Link>
  </li> */}
</ul>


      {/* Logout Button */}
      <div className="logout-container">
  <button className="logout-btn" onClick={handleLogout}>
    <FiLogOut className="icon" /> Logout
  </button>
</div>

    </div>
  );
};

export default Sidebar;
